import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from '../components/Chip';
import FullMatchCard from '../components/FullMatchCard';
import SectionTitle from '../components/SectionTitle';

const FIT_VARIANT = { green: 'success', amber: 'warning', red: 'danger', gray: 'neutral' };

// Mirrors the in-app "Problem Alignment" block (full list of match cards,
// not the page-1 preview style).
const ProblemAlignmentSection = ({ report }) => {
  const a = report.alignment;
  if (!a) return null;
  const matches = a.matches || [];

  return (
    <View>
      {/* Title + lead + first match card grouped so the section header never
          orphans at the bottom of a page. Subsequent match cards flow freely. */}
      <View wrap={false}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
          <Text style={[type.cardTitle, { color: colors.ink }]}>Problem Alignment</Text>
          {a.fitLabel && (
            <Chip variant={FIT_VARIANT[a.fitColor] || 'neutral'}>{a.fitLabel}</Chip>
          )}
        </View>

        {a.lead && (
          <Text style={[type.body, { color: colors.inkSoft, marginTop: space.sm }]}>{a.lead}</Text>
        )}

        {matches.length === 0 ? (
          <Text style={[type.caption, { color: colors.muted, marginTop: space.md }]}>
            Murphy didn't hear any of your addressable problems mentioned in this conversation.
            Consider asking discovery questions about the problems you solve to surface fit signals.
          </Text>
        ) : (
          <View style={{ marginTop: space.md }}>
            <FullMatchCard match={matches[0]} />
          </View>
        )}
      </View>

      {matches.slice(1).map((m, i) => <FullMatchCard key={i + 1} match={m} />)}
    </View>
  );
};

export default ProblemAlignmentSection;
